module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Segment Analysis Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")) + " " + _vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "sgTable"
  }, [_c('tr', [_c('td', {
    staticClass: "td2 td5"
  }, [_vm._v(_vm._s(_vm.$t('Avg Glucose'))), _c('br'), _vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Below ')) + _vm._s(_vm.hypo) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('In Target Range'))), _c('br'), _vm._v(_vm._s(_vm.target))]), _vm._v(" "), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Coefficient of variation')) + " ")]), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('SD'))), _c('br'), _vm._v(" " + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('% Time CGM Active')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.avg))]), _vm._l((_vm.seg), function(item) {
    return _c('td', {
      staticClass: "td4"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.cv))]), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.sd))]), _c('td', [_vm._v(_vm._s(_vm.active))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bolCount"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('# of Boluses')))]), _vm._v(" "), _c('table', {
    staticClass: "countLabel"
  }, [_c('tr', {
    attrs: {
      "id": "count"
    }
  }, _vm._l((48), function(i) {
    return _c('td')
  }))])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_2"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc3e9c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart7_print.vue
// module id = 1475
// module chunks = 7